import { computed } from 'vue';
import { useI18n } from '@/composables';

type FlowNavigationPathItem = {
  name?: string;
  weight: number;
  status?: string;
};

type FlowNavigationPathProps = {
  path: FlowNavigationPathItem;
  paths: FlowNavigationPathItem[];
  ruleStatus?: string;
  pathIndex: number;
};

export const useFlowNavigationPath = (props: FlowNavigationPathProps) => {
  const { t } = useI18n();

  const pathWeightTotal = computed(() =>
    props.paths
      .filter((item) => item.status !== 'inactive')
      .map((item) => +item.weight)
      .reduce((accumulator, item) => accumulator + item, 0),
  );

  const pathName = computed(() => {
    const name = (props.path.name || '').replace('Path', t('Path'));
    return `${name} (# ${props.pathIndex + 1})`;
  });

  const percentName = computed(() => {
    const result = pathWeightTotal.value !== 0
      ? (props.path.weight * 100) / pathWeightTotal.value
      : 0;

    return `${props.path.weight} (${Math.round(result)}%)`;
  });

  return {
    pathName,
    percentName,
  };
};
